var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageRoles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.020752 0.154297V9.00846H8.87492V0.154297H0.020752ZM4.44783 1.8344C5.42016 1.8344 6.20789 2.62248 6.20789 3.59446C6.20789 4.56643 5.41981 5.35451 4.44783 5.35451C3.4762 5.35451 2.68778 4.56643 2.68778 3.59446C2.68778 2.62248 3.4762 1.8344 4.44783 1.8344ZM1.40537 8.39872C1.40537 7.04991 2.49901 5.95661 3.84748 5.95661H5.04785C6.39666 5.95661 7.48996 7.04991 7.48996 8.39872H1.40537Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.020752 20.2004H8.87492V11.3462H0.020752V20.2004ZM4.44783 13.0267C5.42016 13.0267 6.20789 13.8148 6.20789 14.7868C6.20789 15.7588 5.41981 16.547 4.44783 16.547C3.4762 16.547 2.68778 15.7588 2.68778 14.7868C2.68778 13.8145 3.4762 13.0267 4.44783 13.0267ZM3.84748 17.1487H5.04785C6.39666 17.1487 7.48996 18.2424 7.48996 19.5906H1.40537C1.40537 18.2424 2.49901 17.1487 3.84748 17.1487Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5042,
    y: 3.4126,
    width: 10.7667,
    height: 2.26667
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5042,
    y: 15.1709,
    width: 10.7667,
    height: 2.26667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageRoles);
export default __webpack_public_path__ + "static/media/ManageRoles.e5d713040a1e5a358b99b5f8f921d17d.svg";
export { ForwardRef as ReactComponent };